// extracted by mini-css-extract-plugin
export default {"tab":"TabsPanel_tab__qu+h3","unselected":"TabsPanel_unselected__n8Vvc","selected":"TabsPanel_selected__8XSqq"};